var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shutdown"},[_c('div',{staticClass:"app-shutdown__container"},[_c('img',{attrs:{"src":require("@/assets/images/logo/logo-white.svg")}}),_c('h1',[_vm._v("Przepraszamy")]),_c('p',[_vm._v("Placówka wyłączyła możliwość zapisów online.")])])])
}]

export { render, staticRenderFns }